import { wallLogic } from './wall.logic';

import { WallHostView, WallProjectorView, WallStudentView } from './WallViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const wallPlugin: ActivityPlugin<'wall'> = {

  ...wallLogic,

  displayName: GAME_MODE_CATALOG.wall.displayName,

  icon: GAME_MODE_CATALOG.wall.icon,

  HostView: WallHostView,

  StudentView: WallStudentView,

  ProjectorView: WallProjectorView,

};



export { demoWallPayload } from './wall.logic';

